import React from 'react';
import { Node } from '@tiptap/core';
import { ReactNodeViewRenderer, NodeViewWrapper } from '@tiptap/react';
import { PenLine } from 'lucide-react';

export const Signature = Node.create({
  name: 'signature',

  group: 'inline',
  inline: true,
  atom: false,
  selectable: true,
  draggable: true,

  addAttributes() {
    return {
      id: { default: null },
      value: { default: '' },
      label: { default: 'Sign' },
    };
  },

  parseHTML() {
    return [{ tag: 'signature-field' }];
  },

  renderHTML({ HTMLAttributes }) {
    return [
      'span',
      {
        class:
          'inline-flex items-center gap-1.5 px-3 py-1.5 rounded-lg border-2 border-dashed border-rose-300 bg-rose-50/60 text-sm font-medium text-rose-700',
      },
      HTMLAttributes.value || 'Sign here',
    ];
  },

  addCommands() {
    return {
      insertSignature:
        () =>
        ({ commands }) => {
          return commands.insertContent({
            type: this.name,
            attrs: {
              id: crypto.randomUUID(),
              value: '',
            },
          });
        },
    };
  },
});

function SignatureView({ node, getPos }) {
  const onDragStart = (e) => {
    try {
      const from = typeof getPos === 'function' ? getPos() : null;
      const payload = JSON.stringify({
        type: 'editor-drag',
        nodeType: 'signature',
        from,
        id: node.attrs.id,
      });
      e.dataTransfer.setData('application/x-rp-editor', payload);
      e.dataTransfer.setData('text/plain', payload);
      e.dataTransfer.effectAllowed = 'move';
      console.debug('[NodeView] signature dragstart', payload);
    } catch (err) {
      console.log('error ', err.message);
    }
  };

  const display = node.attrs.value || node.attrs.label || 'Sign here';

  return (
    <NodeViewWrapper
      as="span"
      draggable
      onDragStart={onDragStart}
      data-rp-node="signature"
      className="
        inline-flex items-center gap-2 align-middle my-0.5
        rounded-lg border-2 border-dashed border-rose-300/80
        bg-gradient-to-r from-rose-50 to-orange-50/50
        px-3 py-1.5 text-sm font-medium text-rose-700
        shadow-sm transition-all cursor-grab
        hover:border-rose-400 hover:shadow-md
      "
    >
      <span className="flex h-5 w-5 shrink-0 items-center justify-center rounded-md bg-rose-100 text-rose-600 ring-1 ring-rose-200">
        <PenLine className="h-3 w-3" strokeWidth={2.25} />
      </span>
      <span className="italic tracking-wide">{display}</span>
    </NodeViewWrapper>
  );
}

Signature.addNodeView = function () {
  return ReactNodeViewRenderer(SignatureView);
};
